module.exports = __webpack_public_path__ + "img/pro1.f656d01c.svg";